import { PlanType } from '@labrav/react-components'
import {
  AzureOfferPlan,
  AzurePricingType,
  RecurrentPriceModeType,
} from '../../modules/privateOffer/types'
import { useStyles } from './MicrosoftViewPricing.styles'
import { SectionWrapper } from '../../common/components/SectionWrapper/SectionWrapper'
import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { Divider } from '@mui/material'
import clsx from 'clsx'
import { PlanBasicDetail } from './PlanBasicDetail/PlanBasicDetail'
import { isAzureVmProduct } from '../MicrosoftFormComponent/VmPlan/vmPlanUtils'
import { Product } from '../../modules/productsListing/types'
import { ContainerViewPricing } from './ContainerViewPricing/ContainerViewPricing'
import { PlanBillingTerms } from './PlanBillingTerms/PlanBillingTerms'
import { VmViewPricing } from './VmViewPricing/VmViewPricing'
import { isAzureContainerProduct } from '../MicrosoftFormComponent/ContainerPlan/containerPlanUtils'
import { MicrosoftInstallments } from './MicrosoftInstallments/MicrosoftInstallments'
import { PlanMeteringDimensions } from './PlanMeteringDimensions/PlanMeteringDimensions'
import { PlanMinMax } from './PlanMinMax/PlanMinMax'

export const MicrosoftViewPricing = ({
  plans,
  azurePricingType,
  planType,
  product,
}: {
  plans?: AzureOfferPlan[]
  azurePricingType?: AzurePricingType
  planType?: PlanType
  product?: Product
}) => {
  const { classes } = useStyles()
  const productContext = product || ({ productType: planType } as Product)

  if (!plans || plans.length === 0) {
    return (
      <div>
        <SectionWrapper heading="Pricing Plans" icon={faListCheck}>
          <div className={classes.sectionContent}>
            <div className={classes.emptyState}>No plans available</div>
          </div>
        </SectionWrapper>
      </div>
    )
  }

  if (isAzureVmProduct(productContext)) {
    return (
      <VmViewPricing
        plans={plans}
        azurePricingType={azurePricingType}
        product={productContext}
      />
    )
  }

  if (
    planType === PlanType.CONTAINER ||
    isAzureContainerProduct(productContext)
  ) {
    return (
      <ContainerViewPricing
        plans={plans}
        azurePricingType={azurePricingType}
        planType={planType}
      />
    )
  }

  return (
    <div>
      <SectionWrapper heading="Pricing configuration" icon={faListCheck}>
        <div className={classes.sectionContent}>
          {plans.map((plan, index) => {
            const recurrentPriceMode =
              plan.pricing?.recurrentPrice?.recurrentPriceMode
            return (
              <div key={plan.planId || index} className={classes.planCard}>
                <PlanBasicDetail
                  azurePricingType={azurePricingType}
                  plan={plan}
                  index={index}
                />
                <Divider className={classes.divider} />
                <PlanBillingTerms
                  plan={plan}
                  azurePricingType={azurePricingType}
                  recurrentPriceMode={recurrentPriceMode}
                />

                {plan.pricing?.recurrentPrice?.prices[0]?.installments &&
                  plan.pricing?.recurrentPrice?.prices[0]?.installments
                    ?.schedule?.length && (
                    <>
                      <Divider className={clsx(classes.divider)} />
                      <MicrosoftInstallments
                        schedule={
                          plan.pricing?.recurrentPrice?.prices[0]?.installments
                            ?.schedule
                        }
                      />
                    </>
                  )}
                {plan.pricing?.recurrentPrice?.recurrentPriceMode ===
                  RecurrentPriceModeType.FLATRATE &&
                  plan.pricing?.customMeters &&
                  Object.keys(plan.pricing.customMeters.meters || {}).length >
                    0 && (
                    <>
                      <Divider className={clsx(classes.divider)} />
                      <PlanMeteringDimensions plan={plan} />
                    </>
                  )}

                {plan.pricing?.recurrentPrice?.recurrentPriceMode ===
                  RecurrentPriceModeType.PERUSER && (
                  <>
                    <Divider className={clsx(classes.divider)} />
                    <PlanMinMax plan={plan} />
                  </>
                )}
              </div>
            )
          })}
        </div>
      </SectionWrapper>
    </div>
  )
}
